import React, { useState, useEffect } from 'react';
import {
  Card,
} from "tea-component";
import { useIntl } from 'umi';
import { getAnnouncements } from '@/pages/home/services/home';
import { AnnouncementType } from '@/pages/home/types/home';
import Abnormal from '@/pages/home/components/Abnormal';

export default function Announcements(props: any) {
  const { formatMessage } = useIntl() // 中英切换方法
  const [mesage, setMessage] = useState('');
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(false);

  const getAnnouncementsData = async () => {
    setLoading(true)
    try {
      const res: AnnouncementType = await getAnnouncements();
      const _message = res?.content || '';
      setMessage(_message);
      setError(false);
    } catch (err) {
      setError(true);
    } finally {
      setLoading(false);
    }
  }
  useEffect(() => {
    getAnnouncementsData()
  }, []);

  if (!mesage) {
    return null;
  }
  return (
    <Card className='home-card'>
      <Card.Body title={<div className='home-table-title'>{formatMessage({ id: 'dbh_announcements' })}</div>}>
        <Abnormal
          isLoading={loading}
          isError={error}
          isNoData={!mesage}
          style={{ height: 200 }}
          component={
            <div className='home-table-announcetext'>
              {mesage}
            </div>
          }
        />
      </Card.Body>
    </Card>
  );
};
